import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { PATHS } from 'src/common/constants';
import { useAuthFlowsAPI } from 'src/SharedCustomHooks/UseAuthFlowsAPI/useAuthFlowsAPI';

const VALID_EMAIL_REGEX: RegExp =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;

export interface UseForgotPasswordOrchestratorReturn {
  email: string;
  isEmailValid: boolean;
  canSubmit: boolean;
  isSubmitting: boolean;
  updateEmail: (value: string) => void;
  submit: () => Promise<void>;
}

export const useForgotPasswordOrchestrator =
  (): UseForgotPasswordOrchestratorReturn => {
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const { requestPasswordResetEmail } = useAuthFlowsAPI();
    const history = useHistory();

    const trimmedEmail: string = email.trim();
    const isEmailValid: boolean =
      trimmedEmail.length > 0 && VALID_EMAIL_REGEX.test(trimmedEmail.toLowerCase());

    const canSubmit: boolean = isEmailValid;

    const updateEmail = (value: string): void => {
      setEmail(value);
    };

    const submit = async (): Promise<void> => {
      if (!canSubmit) {
        console.warn(
          'useForgotPasswordOrchestrator.submit called while canSubmit is false — submit button should have been disabled.'
        );
        return;
      }

      setIsSubmitting(true);

      const success: boolean = await requestPasswordResetEmail(trimmedEmail);

      setIsSubmitting(false);

      if (success) {
        history.push(PATHS.AUTH_SIGN_IN);
      }
    };

    return {
      email,
      isEmailValid,
      canSubmit,
      isSubmitting,
      updateEmail,
      submit,
    };
  };
